export default __webpack_public_path__ + "static/media/rgb@2x.8afd02df.png";